import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
 Palette,
 CreditCard,
 Building2,
 TrendingUp,
 ListChecks,
 Users,
 Shield,
 Receipt,
} from "lucide-react";
import { Card, CardContent } from "../../components/ui";
import { useAccessControl } from "../../contexts/AccessControlContext";

export const SettingsPage: React.FC = () => {
 const navigate = useNavigate();
 const { t } = useTranslation();
 const { canAccess } = useAccessControl();

 const settingsOptions = [
 {
 icon: Palette,
 title: "Personalização de Cores",
 description:
 "Customize as cores primárias, secundárias e tema do sistema",
 path: "/settings/theme",
 color: "text-accent bg-accent/10 ",
 },
 {
 icon: Building2,
    title: "Configurações da Concessionária",
    description: "Filiais, categorias por filial e dados da empresa",
 path: "/settings/dealership",
 color: "text-accent bg-accent/10",
 },
 ...(canAccess('nav.settings.billing')
 ? [{
 icon: Receipt,
 title: t('billing.settingsCardTitle'),
 description: t('billing.settingsCardDescription'),
 path: '/settings/billing',
 color: 'text-accent bg-accent/10',
 }]
 : []),
 {
 icon: ListChecks,
title: "Configurações de Operação",
description: "Checklist de vendas, tarefas e esteira de preparação",
 path: "/settings/operation",
 color: "text-accent bg-accent/10 ",
 },
{
icon: Users,
title: "Gestão de Leads",
description: "Configure mídias, fontes e catálogo de leads",
path: "/settings/leads",
color: "text-accent bg-accent/10 ",
},
 {
 icon: CreditCard,
 title: "Formas de Pagamento",
 description: "Gerencie as formas de pagamento e opções de financiamento",
 path: "/settings/payment-forms",
 color: "text-accent bg-accent/10 ",
 },
{
icon: TrendingUp,
title: "Avaliação de Veículos",
description: "Gerencie critérios e parâmetros da avaliação de veículos",
path: "/settings/vehicle-evaluation",
color: "text-accent bg-accent/10 ",
},
 ...(canAccess('nav.roleAccess')
 ? [{
 icon: Shield,
 title: t('roleAccess.title'),
 description: t('roleAccess.subtitle'),
 path: '/settings/role-access',
 color: 'text-accent bg-accent/10 ',
 }]
 : []),
 ];

 return (
 <div className="max-w-7xl mx-auto space-y-6">
 <div>
 <h1 className="text-2xl font-bold text-foreground">
 Configurações
 </h1>
 <p className="mt-1 text-sm text-muted-foreground">
 Personalize o sistema de acordo com suas preferências
 </p>
 </div>

 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
 {settingsOptions.map((option) => {
 const Icon = option.icon;
 return (
 <Card
 key={option.path}
 className="cursor-pointer hover:shadow-lg transition-shadow group"
 onClick={() => navigate(option.path)}
 >
 <CardContent className="p-6">
 <div className="flex items-start space-x-4">
 <div className={`p-3 rounded-xl ${option.color}`}>
 <Icon className="h-6 w-6" />
 </div>
 <div className="flex-1">
 <h3 className="font-semibold text-foreground group-hover:text-accent transition-colors">
 {option.title}
 </h3>
 <p className="text-sm text-muted-foreground mt-1">
 {option.description}
 </p>
 </div>
 </div>
 </CardContent>
 </Card>
 );
 })}
 </div>
 </div>
 );
};
